import { SetGetJackpotList } from './thunk/setGetJackpotList'

export const Thunks = {
    SetGetJackpotList
}